import { isValidPhoneNumber } from "react-phone-number-input";

const requiredWith = (message) => (value) =>
  value || typeof value === "number" ? undefined : message;

export const normaliseInstagramHandle = (value) =>
  String(value || "")
    .trim()
    .replace(/^https?:\/\//i, "")
    .replace(/^(www\.)?instagram\.com\//i, "")
    .replace(/^@+/, "")
    .replace(/[/?#].*$/, "");

const HANDLE_FORMAT = /^[A-Za-z0-9._]{1,30}$/;
const NAME_FORMAT = /^[\p{L}\p{M}' -]{1,255}$/u;

const handleFormat = (value) => {
  const handle = normaliseInstagramHandle(value);
  if (!handle || HANDLE_FORMAT.test(handle)) return undefined;
  return "Instagram handles only use letters, numbers, full stops and underscores.";
};

const nameFormat = (message) => (value) => {
  if (!value || NAME_FORMAT.test(value.trim())) return undefined;
  return message;
};

// Shared with the web login form.
export const EMAIL_REQUIRED = "Please enter your email address.";
export const PHONE_REQUIRED = "Please enter your mobile number.";

export const emailFormat = (value) =>
  !value || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
    ? undefined
    : "Please enter a valid email address.";

export const phoneFormat = (value) =>
  !value || isValidPhoneNumber(value)
    ? undefined
    : "That doesn't look like a complete phone number.";

export const firstName = [
  requiredWith("Please enter your first name."),
  nameFormat("Please enter your first name without symbols."),
];

export const lastName = [
  requiredWith("Please enter your family name."),
  nameFormat("Please enter your family name without symbols."),
];

export const phone = [requiredWith(PHONE_REQUIRED), phoneFormat];

export const email = [requiredWith(EMAIL_REQUIRED), emailFormat];

export const homeCity = [requiredWith("Please enter the city you're based in.")];

export const instagram = [requiredWith("Please enter your Instagram handle."), handleFormat];

export const referrer = [
  requiredWith("Please enter the Instagram handle of the member referring you."),
  handleFormat,
];

export const consent = [requiredWith("Please agree to the terms to continue.")];
